import { capitalize } from "~/tools/capitalize";
import type { Result } from "~/tools/result";
import { tryCatch } from "~/tools/try-catch";

export function copyToClipboard(text: string, dataType = "Data"): Result<string, string> {
	const [, isCopied] = tryCatch(() => {
		const textarea = document.createElement("textarea");
		textarea.value = text;
		document.body.appendChild(textarea);
		textarea.select();

		const successful = document.execCommand("copy");

		document.body.removeChild(textarea);

		return successful;
	});

	if (isCopied) {
		return [null, `${capitalize(dataType)} copied to clipboard.`];
	}

	return [
		"Copy to clipboard failed. Browser does not support automatic copying. You can copy manually using your keyboard.",
		null,
	];
}
